import Vincent from "../../../../images/avatar/a-sm.jpg";
import Larry from "../../../../images/avatar/b-sm.jpg";

export const supportData = [
  {
    img: Vincent,
    initial: "VL",
    theme: "purple",
    name: "Vincent Lopez",
    text: "Thanks for contact us with your issues...",
    time: "6 min ago",
    status: "Pending",
  },
  {
    img: null,
    initial: "DM",
    theme: "purple-dim",
    name: "Daniel Moore",
    text: "Thanks for contacting us with your issues",
    time: "2 hours ago",
    status: "Open",
  },
  {
    img: Larry,
    initial: "LH",
    theme: "purple",
    name: "Larry Henry",
    text: "Thanks for contact us with your issues...",
    time: "3 hours ago",
    status: "Solved",
  },
];
